import Image1 from '../../images/svg-1.svg'
import Image2 from '../../images/svg-2.svg'
import Image3 from '../../images/svg-3.svg'

export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Premium Bank',
    headline: 'Unlimited Transactions with zero fees',
    description: 'Get access to our exclusive app that allows you to send unlimited transactions without getting any fees.',
    buttonLabel: 'Get started',
    imgStart: false,
    img: Image1,
    alt: 'Car',
    dark: true,
    primary: true,
    darkText: false
};

export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Unlimited Access',
    headline: 'Login to your account at any time',
    description: 'Use our mobile app to make your money grow, anywhere. All you need is an internet connection and a phone or computer.',
    buttonLabel: 'Learn More',
    imgStart: true,
    img: Image2,
    alt: 'Piggybank',
    dark: false,
    primary: false,
    darkText: true
};

export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Join us today',
    headline: 'Creating an account is a breeze',
    description: 'Get everyting set up and ready in under 10 minutes. Take that, Capital One!',
    buttonLabel: 'Start Now',
    imgStart: false,
    img: Image3,
    alt: 'Paper',
    dark: false,
    primary: false,
    darkText: true
};